export default class AuthTokenHelper {
  static get getAuthToken() {
    return document.querySelector('meta[name=csrf-token]').attributes.content.value;
  }
}
